export default __webpack_public_path__ + "static/media/learn-how.4fb5ef64.png";